<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        :title="detail.id > 0 ? '编辑' : '新建'"
        width="800px"
        top="5vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="detail"
          label-width="auto">
        <el-form-item prop="materialNo" label="物料号" :rules="$rule.notNull">
          <el-input v-model="detail.materialNo" placeholder="请选择物料" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.materialSelect.open()"/>
          </el-input>
        </el-form-item>
        <el-form-item prop="templateName" label="标签模板" :rules="$rule.notNull">
          <el-input v-model="detail.templateName" placeholder="请选择标签模板" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.templateSelect.open()"/>
          </el-input>
        </el-form-item>
        <el-form-item v-if="detail.templateTypeId === 30" prop="customerName" label="客户" :rules="$rule.notNull">
          <el-input v-model="detail.customerName" placeholder="请选择客户" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.customerSelect.open()"/>
          </el-input>
        </el-form-item>
        <el-form-item v-if="detail.templateTypeId === 30" prop="saveSn" label="是否生成条码">
          <el-switch
              v-model="detail.saveSn"
              :active-value="true"
              :inactive-value="false"
              active-text="是"
              inactive-text="否"/>
        </el-form-item>
        <div v-for="(item, index) in detail.items" :key="index">
          <el-form-item
              v-if="!item.hidden"
              :prop="'items.' + index + '.value'"
              :label="item.desc"
              :rules="{required: true, message: '不能为空', trigger: 'change'}">
            <el-input v-model="item.value" :placeholder="'请输入' + item.desc" clearable/>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
    <material-select ref="materialSelect" @select="handleMaterialSelect"/>
    <material-label-print-template-select ref="templateSelect" @select="handleTemplateSelect"/>
    <customer-select ref="customerSelect" @select="handleCustomerSelect"/>
  </div>
</template>

<script>

  import MaterialSelect from "@/views/information/Material/MaterialSelect.vue";
  import MaterialLabelPrintTemplateSelect from "@/views/MaterialLabel/MaterialLabelPrintTemplateSelect.vue";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect.vue";

  export default {
    name: "MaterialLabelPrintEdit",
    components: {CustomerSelect, MaterialLabelPrintTemplateSelect, MaterialSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        detail: {
          id: null,
          materialNo: "",
          templateId: null,
          customerId: null,
          saveSn: false,
          templateTypeId: null,
          templateTypeName: "",
          customerName: "",
          templateName: "",
          templateNote: "",
          items: [],
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        if (id > 0) {
          this.detail.id = id;
          this.getData();
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `materialLabelPrints/${this.detail.id}`)
          .then(resp => {
            this.detail = resp.data;
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },
      handleTemplateSelect(row) {
        this.detail.templateId = row.id;
        this.detail.templateName = row.name;
        this.detail.templateTypeId = row.typeId;
        this.detail.templateTypeName = row.typeName;
        this.detail.items = row.items;
        this.detail.customerId = null;
        this.detail.customerName = "";
        this.detail.saveSn = false;
      },
      handleMaterialSelect(row) {
        this.detail.materialNo = row.materialNO;
      },
      handleCustomerSelect(row) {
        this.detail.customerId = row.customerID;
        this.detail.customerName = row.customerName;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "materialLabelPrints", this.detail)
              .then(res => {
                if (res.success) {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .finally(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>
